import { ProductStats } from "@/@core/entity/product.entity";
import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";
export interface GetProductDetailDTO {
  id: string | undefined;
}

export type GetProductStatsResp = BaseResAPI<ProductStats>;

const getProductStatsInteractor = (): Promise<GetProductStatsResp> => {
  const path = `/admin/product/stats`;

  return api.get(path);
};

export default getProductStatsInteractor;
